<template>
  <div>
    <div class="w-full flex flex-col items-center">
      <div
        class="w-full overflow-hidden flex-col justify-start md:justify-center items-center relative aspect-[4/3] md:aspect-square md:max-h-96 bg-gray-50"
        :class="{
          'hidden md:flex': !pictures || !pictures.length,
          flex: pictures && pictures.length,
        }"
      >
        <template v-if="pictures">
          <transition
            v-for="(picture, index) in pictures"
            :key="index"
            name="fade"
          >
            <NuxtImg
              v-if="currentPicture === index && picture"
              :key="index"
              class="object-contain object-center h-full w-full max-w-full absolute inset-0 bg-white"
              :src="useStrapiImage(picture, 'medium')"
              :alt="picture.alternativeText"
            />
          </transition>
        </template>
        <span v-else>Geen afbeelding beschikbaar</span>
      </div>
      <ul
        v-if="pictures && pictures.length > 1"
        class="flex flex-row pt-5 w-full justify-center gap-3 sm:gap-5"
      >
        <li
          v-for="(picture, index) in pictures"
          :key="index"
          class="rounded relative transition-all border md:border-2 border-dashed"
          :class="[
            {
              'border-los-blue-darkest shadow': currentPicture === index,
              'shadow-sm': currentPicture !== index,
            },
          ]"
        >
          <button
            class="max-h-20 max-w-20 hover-image p-2"
            @click="currentPicture = index"
          >
            <img
              class="h-full w-full object-cover"
              :src="useStrapiImage(picture, 'thumbnail')"
              :alt="picture.alternativeText"
            />
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
defineProps({
  pictures: {
    type: Array,
    default: () => [],
  },
  imageAlt: {
    type: String,
    default: 'Naaimachine',
  },
});

const currentPicture = ref(0);
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
